module.exports = __webpack_public_path__ + "img/hardware5.71cd26e9.jpg";